import { useTranslation } from 'next-i18next';
import { useQrScanner } from '../hooks/useQrScanner';
type Props = {
  /** 스캔된 raw 텍스트. 파싱/검증은 상위(handleScan)에서 수행한다. */
  onScan: (text: string) => void;
};

/**
 * QR 카메라 영역(시안 434:15910 — h230, rounded-sm, border).
 * 카메라를 쓸 수 없으면 같은 박스 안에 수동 입력 안내를 노출해
 * 빈 박스가 남지 않게 한다("학생 코드 입력하기" 버튼으로 코드 입력 전환 가능).
 */
export function QrScanner({
  onScan
}: Props) {
  const {
    t
  } = useTranslation('classroom');
  const {
    videoRef,
    available
  } = useQrScanner(onScan);
  return <div className="relative h-[230px] w-full overflow-hidden rounded-sm border border-alternative bg-default" data-sentry-component="QrScanner" data-sentry-source-file="QrScanner.tsx">
      {available ? <>
          <video ref={videoRef} className="size-full object-cover" />
          {/* 시안 434:16342 — 카메라 위 QR 가이드 오버레이(흰색 벡터, opacity 0.64 내장) */}
          <img src="/assets/qr-scan-overlay.svg" alt="" aria-hidden className="pointer-events-none absolute left-1/2 top-1/2 size-[220px] -translate-x-1/2 -translate-y-1/2" />
        </> : <div className="flex size-full items-center justify-center px-md text-center text-body-sm-medium text-assistive">
          {t('codeLogin.cameraUnavailable')}
        </div>}
    </div>;
}